import { FONT, IMAGE } from 'ContentUtils/constants/CustomWidgetFieldTypes';
import { FONT_SETS, FONT_STYLES } from 'ContentUtils/constants/Fonts';
import { isObject } from './object';
// TODO Remove when hot reloading is ungated to all

const fieldValueParsers = {
  [FONT](value) {
    const {
      styles = {}
    } = value;
    let {
      font = ''
    } = value;
    let {
      ['font-weight']: fontWeight,
      ['font-style']: fontStyle,
      ['text-decoration']: textDecoration
    } = styles;
    if (value.font_set === FONT_SETS.GOOGLE) {
      const {
        fallback,
        variant = ''
      } = value;
      if (font && fallback) {
        font = `'${font}', ${fallback}`;
      }
      if (/^\d+(regular|italic)?$/.test(variant)) {
        fontWeight = parseInt(variant, 10);
      }
      if (/^(\d+)?italic$/.test(variant)) {
        fontStyle = 'italic';
      }
    }
    const {
      [FONT_STYLES.BOLD]: deprecatedBoldStyle,
      [FONT_STYLES.ITALIC]: deprecatedItalicStyle,
      [FONT_STYLES.UNDERLINE]: deprecatedUnderlineStyle
    } = styles;
    if (deprecatedBoldStyle && !fontWeight) {
      fontWeight = 'bold';
    }
    if (deprecatedItalicStyle && !fontStyle) {
      fontStyle = 'italic';
    }
    if (deprecatedUnderlineStyle && !textDecoration) {
      textDecoration = 'underline';
    }
    if (!fontWeight) fontWeight = 'normal';
    if (!fontStyle) fontStyle = 'normal';
    if (!textDecoration) textDecoration = 'none';
    return Object.assign({}, value, {
      font,
      styles: {
        'font-weight': fontWeight,
        'font-style': fontStyle,
        'text-decoration': textDecoration,
        // TODO remove deprecated font styles
        [FONT_STYLES.BOLD]: fontWeight,
        [FONT_STYLES.ITALIC]: fontStyle,
        [FONT_STYLES.UNDERLINE]: textDecoration
      }
    });
  },
  [IMAGE](value) {
    return {
      src: value.src ? `url(${value.src})` : ''
    };
  }
};
export const getCSSVariableKey = fieldKey => ['--theme', ...fieldKey].join('-');

// @ts-expect-error ts-migrate(7023) FIXME: 'getFieldCSSVariablesMap' implicitly has return ty... Remove this comment to see the full error message
const getFieldCSSVariablesMap = (field, fieldSettingsValue, parentFieldKey = []) => {
  const fieldKey = parentFieldKey.concat(field.name);
  if (field.children) {
    return field.children.reduce((finalMap, child) => {
      const childSettingsValue = fieldSettingsValue && isObject(fieldSettingsValue) ? fieldSettingsValue[child.name] : null;
      const childMap = getFieldCSSVariablesMap(child, childSettingsValue, fieldKey);
      Object.assign(finalMap, childMap);
      return finalMap;
    }, {});
  }
  let fieldValue = fieldSettingsValue != null ? fieldSettingsValue : field.default;
  if (fieldValue == null) {
    return {};
  }

  // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
  if (fieldValueParsers[field.type]) {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    fieldValue = fieldValueParsers[field.type](fieldValue);
  }
  if (isObject(fieldValue)) {
    return Object.keys(fieldValue).reduce((finalMap, key) => {
      // @ts-expect-error ts-migrate(7022) FIXME: 'fieldValueMap' implicitly has type 'any' because ... Remove this comment to see the full error message
      const fieldValueMap = getFieldCSSVariablesMap({
        name: key,
        type: `${field.type}:${key}`
      }, fieldValue[key], fieldKey);
      Object.assign(finalMap, fieldValueMap);
      return finalMap;
    }, {});
  }
  const fieldVariableKey = getCSSVariableKey(fieldKey);
  return {
    [fieldVariableKey]: fieldValue
  };
};
export const getCSSVariablesMap = (theme, themeSettings = {}) => {
  const {
    fields
  } = theme;
  if (!fields) {
    return {};
  }
  return fields.reduce((finalMap, field) => {
    // @ts-expect-error ts-migrate(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    const fieldMap = getFieldCSSVariablesMap(field, themeSettings[field.name]);
    Object.assign(finalMap, fieldMap);
    return finalMap;
  }, {});
};